import { Grid } from '@mui/material';
import { useMemo } from 'react';

import { SourcingCaseCancelledAlert } from '@/legacy/components/SourcingCaseCancelledAlert/SourcingCaseCancelledAlert';
import { ModuleEntityType } from '~/common/types';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ModuleSlotId } from '~/modules';
import { useSourcingCase } from '~/modules/Module.hooks';
import { RouteId } from '~/routes/RouteId';

import { SourcingCaseDetailHeader } from './components/SourcingCaseDetailHeader';

export const SourcingCaseDetail = () => {
  const { id, tabId } = useSourcingCase();

  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.sourcingCaseDetail(), tabId });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.SOURCING_CASE, entityId: id }),
    [id],
  );

  return (
    <>
      <ModulePage
        header={<SourcingCaseDetailHeader id={id} tabs={tabs} />}
        modules={
          <ModuleContextProvider value={contextValue}>
            <>
              <Grid size={12}>
                <SourcingCaseCancelledAlert sourcingCaseId={id} />
              </Grid>
              <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
            </>
          </ModuleContextProvider>
        }
      />
    </>
  );
};
